module.exports = __webpack_public_path__ + "static/media/952782968e924cf.642103a4.mp3";